var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.usps.length)?_c('div',{staticClass:"top-badges"},_vm._l((_vm.usps),function(usp,i){return _c('span',{key:i,staticClass:"usp-badge",class:`usp-badge--${_vm.getUspType(usp.type)}`,style:({
      backgroundColor: `${usp.color || '#696969'}1A`,
      borderColor: usp.color || '#696969',
      color: usp.color || '#696969',
    })},[_vm._v("\n    "+_vm._s(usp.text)+"\n  ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }